// import AlliedCamera from '../../routes/SmartInspect/Warren/assets/maintenance/5.1-allied-camera.png';
// import AlliedConnections from '../../routes/SmartInspect/Warren/assets/maintenance/5.2-allied-camera-connections.png';
// import ChannelBoard from '../../routes/SmartInspect/Warren/assets/maintenance/5.3-channel-board.png';
// import LEDHeader from '../../routes/SmartInspect/Warren/assets/maintenance/5.4-LED-header-board.png';
// import ArchDoubleWide from '../../routes/SmartInspect/Warren/assets/maintenance/5.5-arch-double-wide-LED.png';
// import ArchBoards from '../../routes/SmartInspect/Warren/assets/maintenance/5.6-arch-light-boards.png';
// import WideBoards from '../../routes/SmartInspect/Warren/assets/maintenance/5.7-LED-wide-light-boards.png';
// import ArchConnecions from '../../routes/SmartInspect/Warren/assets/maintenance/5.8-light-arch-connections.png';
// import DoubleWideConnections from '../../routes/SmartInspect/Warren/assets/maintenance/5.9-double-wide-connections.png';
import TriggerBoard from '../../routes/SmartInspect/Warren/assets/maintenance/5.10-trigger-board-connections.png';
import PDP from '../../routes/SmartInspect/Warren/assets/equipment/3.12-PDP.png';

// import ArchHousing from '../../routes/SmartInspect/Warren/assets/maintenance/5.11-arch-light-housing.png';
// import DoubleHousing from '../../routes/SmartInspect/Warren/assets/maintenance/5.12-double-wide-housing.png';
import styled from 'styled-components';
import BSCarousel from 'react-bootstrap/Carousel';

const CarouselComp = ({ className }) => {
	return (
		<BSCarousel className={className} fade variant="dark" interval={null}>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 1</h3>
					<h2 style={{ width: '50%', margin: 'auto' }}>
						Before replacing the trigger board make sure to first troubleshoot the issue in <a href="/smart-inspect/warren/troubleshooting/hardware-troubleshooting">Triggerboard Troubleshooting</a> section of this manual to ensure replacement is necessary.
					</h2>
				</BSCarousel.Caption>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 2</h3>
					<p>
						Perform system power down/lock out as outlined in this manual and on the lock out placard located on the front of the{' '}
						<b>
							<b>PDP</b>
						</b>
						.
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={PDP} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: PDP</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 3</h3>
					<p>
						Locate the trigger board housing within the <b>PDP</b>, lower left of the cabinet.
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 4</h3>
					<p>Remove the screws retaining the front portion of the housing to expose the trigger board assembly.</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 5</h3>
					<p>
						Switch the trigger boards on/off switch up to the off position (see <b>Figure 1: Trigger Board Connections/Layout</b>).
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 6</h3>
					<p>
						Ensure the power is off to the board by checking the indicator LED’s, all of them should be off (see <b>Figure 1: Trigger Board Connections/Layout</b>).
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 7</h3>
					<p>
						Remove the large green two pin 24V trigger board power plug by grasping and pulling upward/outward. (see <b>Figure 1: Trigger Board Connections/Layout</b>).
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 8</h3>
					<p>
						Remove the Pi data cable labeled ENET-TRIG by pinching tab and pulling outward (see <b>Figure 1: Trigger Board Connections/Layout</b>).
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 9</h3>
					<p>
						Remove the FPGA programing micro USB cable plugged into the FPGA programing port by grasping and pulling outward (see <b>Figure 1: Trigger Board Connections/Layout</b>).
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 10</h3>
					<p>
						Remove the four large multi pin block connectors by grasping and pulling upward from both sides of the connector body. Be very careful to not break the connector and or connector header. Do <b>NOT</b> pull on the wires to remove the block connectors.
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 11</h3>
					<p>
						Do <b>NOT</b> remove the FPGA, Raspberry Pi or Pi micro USB power cable as they will come with the new trigger board and are a part of the assembly.
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 12</h3>
					<p>Locate and remove the mounting screws attaching the trigger board to the inner housing, then carefully lift the trigger board assembly up and out of the housing.</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 13</h3>
					<p>Install the new trigger board assembly into the board housing and secure with the mounting screws previously removed.</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 14</h3>
					<p>Attach the four large multi pin block connectors into their associated ports by grasping the connector body and pressing them into place until flush with the header. Be very careful to not break the connector and or connector header.</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 15</h3>
					<p>
						Attach the FPGA programing micro USB cable to the FPGA programing port by aligning and inserting into the port until it is secured in place (see <b>Figure 1: Trigger Board Connections/Layout</b>).
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 16</h3>
					<p>
						Attach the Pi data cable labeled ENET-TRIG by aligning the tab and inserting into the port until it locks in place (see <b>Figure 1: Trigger Board Connections/Layout</b>).
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 17</h3>
					<p>
						Attach the large green two pin 24V trigger board power plug into the header by aligning and inserting into the header until it is flush and secure. (see <b>Figure 1: Trigger Board Connections/Layout</b>).
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 18</h3>
					<p>
						Ensure that the 3 amp blade fuse is installed in the trigger board fuse holder (see <b>Figure 1: Trigger Board Connections/Layout</b>).
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 19</h3>
					<p>
						Ensure the raspberry Pi power cable is secure on both ends (see <b>Figure 1: Trigger Board Connections/Layout</b>).
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 20</h3>
					<p>Ensure none of the wires attached to the four large block connectors have come loose, if so reinstall or repair before moving on.</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 21</h3>
					<p>
						Switch the trigger boards on/off switch down to the on position (see <b>Figure 1: Trigger Board Connections/Layout</b>).
					</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 22</h3>
					<p>Install the front portion of the trigger board housing with the screws previously removed.</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 23</h3>
					<p>Perform unlock procedure and restore power to the system.</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
			<BSCarousel.Item>
				<BSCarousel.Caption>
					<h3>STEP 24</h3>
					<p>The indictor lights located on the trigger board will now be illuminated.</p>
				</BSCarousel.Caption>
				<div class="d-flex" style={{ justifyContent: 'center' }}>
					<figure>
						<img className="d-block w-100" src={TriggerBoard} alt="Third slide" style={{ height: '44vh' }} />
						<figcaption>Figure 1: Trigger Board Connections/Layout</figcaption>
					</figure>
				</div>
			</BSCarousel.Item>
		</BSCarousel>
	);
};

const TriggerBoardSMP = styled(CarouselComp)`
	width: 65vw;
	margin: 0 auto;

	.carousel-inner {
		border-radius: 2em;
		min-height: 50vh;
	}

	.carousel-indicators {
		bottom: -20px;
	}

	.carousel-caption {
		position: relative;
		background: white;
		color: #000;
		width: 100%;
		left: 0;
		right: 0;
		bottom: 0;

		& h3 {
			text-align: center;
		}
	}

	@media screen and (max-width: 480px) {
		width: 89vw;
	}
`;

export default TriggerBoardSMP;
